<div class="input-group">
    <select class="form-select" name="Hora" [(ngModel)]="valueHora">
        <option *ngFor="let hora of this.horasPosibles" value="{{ hora }}">{{ this.padWithZeros(hora,2) }}</option>
    </select>
    <select class="form-select" name="Minuto" [(ngModel)]="valueMinutos">
        <option *ngFor="let minuto of this.minutosPosibles" value="{{ minuto }}">{{ this.padWithZeros(minuto,2) }}</option>
    </select>
</div>